// extracted by mini-css-extract-plugin
module.exports = {"box":"styles_box__Wv29w","logo":"styles_logo__1UPha","ft":"styles_ft__1ow7C","btn1":"styles_btn1__2OnjL","btn2":"styles_btn2__25jXH"};